import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import initVideo, { destroyVideo, extractEmbedSource } from '../../../utils/embed';
import s from './VideoEmbed.scss';

const VideoEmbed = ({ content, uid, img = null }) => {
	// const aspectRatio = content.aspectRatio.split('-').map(Number).reduce((acc, value) => (!acc ? value : (value / acc)), null);
	const videoEmbedSrc = content.url && extractEmbedSource(content.url, `${uid}`);

	useEffect(() => {
		initVideo(videoEmbedSrc, uid, { autoplay: 1, loop: 1, mute: 1 });

		return () => {
			destroyVideo(videoEmbedSrc, uid);
		};
	});

	return (
		<figure className={s.videoEmbed}>
			<div id={`iframe-${videoEmbedSrc}-${uid}`}>{ img }</div>
			{ content.caption && <figcaption className={s.videoEmbed_caption} dangerouslySetInnerHTML={{ __html: purifier(content.caption.rawText) }} /> }
		</figure>
	);
};

export default hot(module)(VideoEmbed);
